import { createSlice } from '@reduxjs/toolkit';
import endpointsStatuses from '../models/endpointsStatuses';

const initialState = {
    tags: null,
    domains: null,
    providers: null,
    providersHost: null,
    connectorsProcessStatus: null,
    general: null,
    usefulTools: null,
    permissionLlist: null,
    permissionFilters: null,
    shortcut: null,
    platforms: null,
    home: null,
};

const uiDataSlice = createSlice({
    name: "uiData",
    initialState,
    reducers: {
        initMetaDataData(state, action) {
            state.domains = action.payload.domains
            state.tags = action.payload.tags
            state.providers = action.payload.providers;
            state.providersHost = action.payload.providersHost;
            state.generalConnector = action.payload.generalConnector;
            state.connectorsProcessStatus = state.providers.reduce((providersObj, provider) => {
                providersObj[provider.name] = provider.endpoints && Object.keys(provider.endpoints).reduce((endpointsObj, key) => {
                    endpointsObj[key] = {
                        status: endpointsStatuses.start,
                        sections: provider.endpoints[key].sections
                    };
                    return endpointsObj;
                }, {});
                return providersObj;
            }, {});
            state.platforms = action.payload.platforms
        },
        updateConnectorsProcessStatus(state, action) {
            const { providerName, endpoint, status } = action.payload
            state.connectorsProcessStatus = {
                ...state.connectorsProcessStatus,
                [providerName]: {
                    ...state.connectorsProcessStatus[providerName],
                    [endpoint]: {
                        ...state.connectorsProcessStatus[providerName][endpoint],
                        status: status
                    }
                }
            };
        },
        initGeneral(state, action) {
            state.general = action.payload
        },
        initUsefulTools(state, action) {
            state.usefulTools = action.payload
        },
        initFinalProjectStudents(state, action) {
            state.permissionLlist = action.payload
        },
        initPermissionFilters(state, action) {
            state.permissionFilters = action.payload
        },
        initShortcut(state, action) {
            state.shortcut = action.payload
        },
        initHome(state, action) {
            state.home = action.payload
        }
    }
})

export const uiDataActions = uiDataSlice.actions;
export default uiDataSlice
